// extracted by mini-css-extract-plugin
export default {"button":"Button_button__rlW9C","primary":"Button_primary__48Ziw","outlined":"Button_outlined__EDKdV"};